var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import ApplicableDiscountsForm from "../../../components/applicable-discounts/ApplicableDiscountsForm";
import { FormProvider, useForm } from "react-hook-form";
import { completedPage, selectedDiscounts } from "../../../lib/Avo";
import { saveDriverApplicableDiscounts, setEntityState, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { useHistory, useLocation } from "react-router-dom";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import useDriverDiscounts from "../../../hooks/useDriverDiscounts";
export default function UnlinkedApplicationAutoApplicableDiscounts() {
    var dispatch = useAppDispatch();
    var _a = useHistory(), push = _a.push, goBack = _a.goBack;
    var search = useLocation().search;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = useAppSelector(function (state) {
        var params = new URLSearchParams(search);
        var _a = state.unlinkedApplication, policyHolder = _a.policyHolder, drivers = _a.auto.drivers;
        var driverId = params.get("driverId");
        var driverData = drivers.find(function (driver) { return driver.id === driverId; });
        return {
            driverData: driverData,
            drivers: drivers,
            policyHolder: policyHolder,
        };
    }), driverData = _b.driverData, drivers = _b.drivers, policyHolder = _b.policyHolder;
    var _c = useDriverDiscounts({
        driverData: driverData,
        drivers: drivers,
        policyHolder: policyHolder,
    }), isPolicyHolder = _c.isPolicyHolder, checkedDiscountsByDefault = _c.checkedDiscountsByDefault;
    var formMethods = useForm({
        mode: "all",
        defaultValues: checkedDiscountsByDefault,
    });
    var watchedInputs = formMethods.watch();
    var driverId = driverData === null || driverData === void 0 ? void 0 : driverData.id;
    var storeValues = React.useCallback(function (applicableDiscounts) {
        if (driverId) {
            dispatch(saveDriverApplicableDiscounts({
                id: driverId,
                discounts: applicableDiscounts,
            }));
        }
    }, [dispatch, driverId]);
    var onSubmit = formMethods.handleSubmit(function (discountsFormData) {
        var discountsArray = Object.entries(discountsFormData)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return (value ? key : null);
        })
            .filter(function (key) { return key !== null; });
        var stringifiedDiscounts = discountsArray.join(", ");
        selectedDiscounts(__assign(__assign({}, commonAnalyticsProperties), { applicableDiscounts: discountsArray, isForSpouse: !isPolicyHolder }));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: stringifiedDiscounts, optionSelected: stringifiedDiscounts }));
        storeValues(discountsFormData);
        push(PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS);
    });
    var setEditingState = React.useCallback(function () {
        dispatch(setEntityState({ drivers: { mode: "edit", editId: driverData === null || driverData === void 0 ? void 0 : driverData.id } }));
    }, [dispatch, driverData]);
    var handleClose = React.useCallback(function () {
        storeValues(watchedInputs);
        setEditingState();
    }, [storeValues, setEditingState, watchedInputs]);
    var handleGoBack = React.useCallback(function () {
        storeValues(watchedInputs);
        setEditingState();
        goBack();
    }, [storeValues, setEditingState, goBack, watchedInputs]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true, onClose: handleClose, goBackOverride: handleGoBack },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(FormProvider, __assign({}, formMethods),
                    React.createElement(ApplicableDiscountsForm, { isPolicyHolder: isPolicyHolder, onSubmit: onSubmit }))))));
}
